import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/BlogsMenu.scss";
import Particles from '@tsparticles/react';


const metadataPath = process.env.PUBLIC_URL + "/assets/markdown_metadata.json";

const BlogsMenu = () => {

  const [isLoading, setLoading] = useState(false);
  const [metadataObj, setmetadata] = useState({});
  async function loadFile() {
    setLoading(true);
    try {
      let metadataJson = await fetch(metadataPath);
      metadataJson = await metadataJson.text();
      setmetadata(JSON.parse(metadataJson));
      setLoading(false);
    } catch (error) {
      alert("An Error has occured");
      // setError(true);
      console.log("ERRR");
    }
  }

  useEffect(() => {
    loadFile();
  }, []);

  if (isLoading) {
    return <div>Loading ...</div>
  }
  const stringExtractor = (s, prefix, suffix) => {
    var i = s.indexOf(prefix);
    if (i >= 0) {
      s = s.substring(i + prefix.length);
    } else {
      return "";
    }
    if (suffix) {
      i = s.indexOf(suffix);
      if (i >= 0) {
        s = s.substring(0, i);
      } else {
        return "";
      }
    }
    return s;
  }
  const particleParams = {
    "particles": {
      "number": {
        "value": 50
      },
      "size": {
        "value": 3
      }, 
      move:{
        enable:true
      }
    },
    "interactivity": {
      "events": {
        "onHover": {
          "enable": true,
          "mode": "grab"
        },

      },
      "modes": {
        "grab": {
          "distance": 250,

        },
      }
    }
  }

  return (
    <>
      <Particles id="particlesBlogMenu"
        options={particleParams} />
      <Container>
        <Row className='my-5 mx-5'>
          <h1 style={{ color: 'whitesmoke' }}>Blogs</h1>
        </Row>

        <Row>

          {Object.values(metadataObj).map((value, index) => {
            return (
              <Col key={value.title}>
                <div className="cardContainer">
                  <Link to={`/blogs/${value.dirName}`} style={{ textDecoration: 'none' }}>
                    <Card className="cardStyle" >
                      <Card.Img className="cardImage" variant="top"
                        // this removes the ./public from the thumbnail path, and replaces it with the process.env.public path
                        src={value.thumbnail ? `${process.env.PUBLIC_URL}${stringExtractor(value.thumbnail, './public')}`
                          : `${process.env.PUBLIC_URL}/assets/images/brushes-3129361.jpg`} />
                      <Card.Body className="cardBody">
                        <Card.Title>{value.title}</Card.Title>
                        <Card.Text>
                          {value.description}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Link>
                </div>

              </Col>
            )
          })}

        </Row>

      </Container>
    </>
  );
}

export default BlogsMenu;